module.exports = __webpack_public_path__ + "img/Hainan-power.3b58057e.png";